import { Alert } from '@mui/material'
import { useStore } from '../stores'
import { observer } from 'mobx-react'

const AlertModal = observer(
  ({
    variant = 'standard'
  }: {
    variant: 'standard' | 'filled' | 'outlined'
  }) => {
    const { app: appStore } = useStore()

    if (appStore.apiResponse === null) return null
    return (
      <Alert variant={variant} color={appStore.responseAlertColor}>
        {appStore.responseAlertMessage}
      </Alert>
    )
  }
)

export default AlertModal
